const styles = theme => ({

	root: {
		width: '100%',
	},
});

export default styles;